module.exports = __webpack_public_path__ + "img/4.5eb89a23.jpg";